"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingPage = exports.MissingPageConfig = void 0;
var tslib_1 = require("tslib");
var theme_1 = require("../components/theme");
var i18n_1 = require("../i18n");
var mithril_1 = require("../mithril");
var services_1 = require("../services");
var page_1 = require("./page");
var CSS = {
    container: 'c-Missing',
    left: 'c-Missing__Left',
    right: 'c-Missing__Right',
    errorName: 'c-Missing__Error-Name',
    errorDescription: 'c-Missing__Error-Description'
};
var Style = (_a = {},
    _a[CSS.container] = {
        width: '100%',
        height: '100%',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'background-color': theme_1.DefaultTheme.background.darkGrey
    },
    _a[CSS.left] = {
        'justify-content': 'center',
        'align-items': 'center',
        'margin-right': theme_1.DefaultTheme.space(14),
        'font-size': '112px',
        color: theme_1.DefaultTheme.color.accent
    },
    _a[CSS.right] = {
        color: theme_1.DefaultTheme.background.offWhite
    },
    _a[CSS.errorName] = {
        'font-size': theme_1.DefaultTheme.space(21),
        'margin-bottom': theme_1.DefaultTheme.space(12),
        'line-height': 1
    },
    _a[CSS.errorDescription] = {
        'font-size': theme_1.DefaultTheme.space(5)
    },
    _a);
(0, theme_1.addStyles)(Style);
// todo: we could use Proxy once we get rid of IE :)
var MissingErrors = {
    404: {
        errorCode: i18n_1.T.MISSING_404_CODE,
        errorTitle: i18n_1.T.MISSING_404_TITLE,
        errorBeforeLink: i18n_1.T.MISSING_404_BEFORE_LINK,
        errorLinkText: i18n_1.T.MISSING_404_LINK,
        errorAfterLink: i18n_1.T.MISSING_404_AFTER_LINK
    },
    403: {
        errorCode: i18n_1.T.MISSING_403_CODE,
        errorTitle: i18n_1.T.MISSING_403_TITLE,
        errorBeforeLink: i18n_1.T.MISSING_404_BEFORE_LINK,
        errorLinkText: i18n_1.T.MISSING_403_LINK,
        errorAfterLink: i18n_1.T.MISSING_404_AFTER_LINK
    }
};
exports.MissingPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.pageMissing,
    path: '/error',
    auth: {
        required: false
    },
    layout: { nav: false }
};
var MissingPage = /** @class */ (function (_super) {
    tslib_1.__extends(MissingPage, _super);
    function MissingPage(errorType) {
        if (errorType === void 0) { errorType = 404; }
        var _this = _super.call(this, exports.MissingPageConfig) || this;
        _this.errorType = errorType;
        // If the user is not authenticated, then we dont want to show the top bar
        if (!services_1.Services.User.isAuthenticated) {
            _this.config.layout = { banner: false };
        }
        return _this;
    }
    Object.defineProperty(MissingPage.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: CSS.container }, [
                (0, mithril_1.m)('div', { className: CSS.left }, (0, i18n_1.Translate)(MissingErrors[this.errorType].errorCode)),
                (0, mithril_1.m)('div', { className: CSS.right }, [
                    (0, mithril_1.m)('div', { className: CSS.errorName }, (0, i18n_1.Translate)(MissingErrors[this.errorType].errorTitle)),
                    (0, mithril_1.m)('div', { className: CSS.errorDescription }, [
                        (0, mithril_1.m)('span', (0, i18n_1.Translate)(MissingErrors[this.errorType].errorBeforeLink)),
                        (0, mithril_1.m)('a', { href: services_1.Services.User.isAuthenticated ? '/#/map' : '/#/login' }, (0, i18n_1.Translate)(MissingErrors[this.errorType].errorLinkText)),
                        (0, mithril_1.m)('span', (0, i18n_1.Translate)(MissingErrors[this.errorType].errorAfterLink))
                    ])
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    return MissingPage;
}(page_1.IkePage));
exports.MissingPage = MissingPage;
//# sourceMappingURL=missing.page.js.map